// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ibi15R6VkaPevLtpTPSVi"};